var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-skill-viewer" },
    [
      _c(
        "SkillViewer",
        _vm._g(
          _vm._b(
            {
              attrs: {
                skills: _vm.newList,
                "child-key": "skillModelMaps",
                legends: _vm.legends,
                radius: _vm.previewRadius,
                axis: _vm.previewAxis,
                options: _vm.radarOption,
                "show-skill-level": _vm.enableSkillLevel,
                "enable-weight-switch": _vm.enableWeightSwitch,
                "enable-excellent-level": _vm.enableExcellentLevel,
                checkbox: _vm.checkbox,
              },
            },
            "SkillViewer",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }